module.exports = __webpack_public_path__ + "./assets/graphic_professionalPlan.svg";